export const environment = {
   production: true,
   env: 'prod',
   apiUrl: 'https://api.holistahealth.com/api',
   googleMapsApiKey: "AIzaSyAEfKyo3lDmvL-ZmgY-NCv4j4Cq-Lmzn3E"
  }